import React, {
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import api from "../../utils/axios";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import classes from "./Register.module.css";
import DefaultInput from "../../components/form/DefaultInput";
import DefaultSelect from "../../components/form/DefaultSelect";
import TextArea from "antd/es/input/TextArea";
import { ReactComponent as OrderBox } from "../../assets/order-box.svg";
import DefaultSwitch from "../../components/form/DefaultSwitch";
import Buttons from "../../components/form/Buttons";
import { extractQueryParameters } from "../../utils/extractQueryParameters";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import L, { Icon, LatLngTuple } from "leaflet";
import { Alert, Button, Divider, Modal, Select, SelectProps } from "antd";
import { toast } from "react-toastify";
import "leaflet/dist/leaflet.css";
import { fetchZones, getConfigurationValue } from "../../lib/OptionListApi";
import { useNavigate } from "react-router";
import useLang from "../../hooks/useLang";
import { ReactComponent as AlertIcon } from "../../assets/AlertIcon.svg";
import { Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { CONFIG } from "../../config";
import AddressSelect from "../../components/form/AddressSelect";

interface IOrderInsertData {
	[name: string]: any;
}

interface Zone {
	id: number;
	description: string;
	levelId: number;
	parentId: any;
}

type PackageWeightDefaults = {
	id: number;
	from: number;
	to?: number;
	price?: number;
	number?: number;
};

type PackageValueDefaults = {
	id: number;
	from: number;
	to?: number;
	percentage?: number;
	number?: number;
};

const Register = () => {
	const currentURL = window.location.search;
	const queryParams = extractQueryParameters(currentURL);
	const buyerId = queryParams.id;
	const navigate = useNavigate();

	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [address, setAddress] = useState("");
	const [sectionId, setSectionId] = useState<number | null>(0);
	const [phone, setPhone] = useState("");
	const [email, setEmail] = useState("");
	const [addressDetails, setAddressDetails] = useState("");
	const [width, setWidth] = useState(20);
	const [length, setLength] = useState(20);
	const [height, setHeight] = useState(20);
	const [weight, setWeight] = useState(0.5);
	const [openable, setOpenable] = useState(true);
	const [isExistingPhoneNumberVisible, setIsExistingPhoneNumberVisible] =
		useState<boolean>(false);
	const [fragile, setFragile] = useState(false);
	const [declared, setDeclared] = useState(false);
	const [invoice, setInvoice] = useState(false);
	const [exchangeable, setExchangeable] = useState(false);
	const [deliveryInstructions, setDeliveryInstructions] = useState("");
	const [orderPrice, setOrderPrice] = useState<any>("");
	const [currencyId, setCurrencyId] = useState(1);
	const [orderDescription, setOrderDescription] = useState("");
	const [packageDescription, setPackageDescription] = useState("");
	const [zones, setZones] = useState<Zone[]>([]);
	const [selectedCountry, setSelectedCountry] = useState<
		string | number | undefined
	>();
	const [selectedCity, setSelectedCity] = useState<
		string | undefined | number
	>();
	const [fullName, setFullName] = useState("");
	const [fromBuyerPage, setFromBuyerPage] = useState(false);
	const [temporaryBuyerDetailsId, setTemporaryBuyerDetailsId] = useState();
	const [temporaryBuyerDetails, setTemporaryBuyerDetails] = useState();
	const [selectedFile, setSelectedFile] = useState<File | null>(null);
	const [refId, setRefId] = useState<number | null>();
	const [ordersRealPrice, setOrdersRealPrice] = useState<any>(0);
	const [waitingPickup, setWaitingPickup] = useState<boolean>(false);
	const [openVatModal, setOpenVatModal] = useState<boolean>(false);
	const [vat, setVat] = useState<any>(0);
	const [orderPriceNoVat, setOrderPriceNoVat] = useState<any>(0);
	const [buyerDropDown, setBuyerDropDown] = useState<any[]>();
	const [searchText, setSearchText] = useState<string>("");
	const [costums, setCostums] = useState([]);

	//Map leaflet
	const [latitude, setLatitude] = useState<number | null>(null);
	const [longitude, setLongitude] = useState<number | null>(null);
	const [error, setError] = useState<string | null>(null);
	const [mapCenter, setMapCenter] = useState<LatLngTuple | null>(null);
	const markerRef = useRef(null);
	const [position, setPosition] = useState<any>(null);
	const [adressPosition, setAddressPosition] = useState<any>(null);
	const [finalAddress, setFinalAddress] = useState<string>("");
	const [countryLabel, setCountryLabel] = useState<string>("xk");
	const [geoData, setGeoData] = useState<any>();
	const [apiLatitude, setApiLatitude] = useState<number | null>();
	const [apiLongitude, setApiLongitude] = useState<number | null>();

	const [nameError, setNameError] = useState<boolean>(false);
	const [addressError, setAddressError] = useState<boolean>(false);
	const [phoneError, setPhoneError] = useState<boolean>(false);
	const [openOrdersRealPriceModal, setOpenOrdersRealPriceModal] =
		useState<boolean>(false);
	const [packageDescriptionError, setPackageDescriptionError] =
		useState<boolean>(false);
	const [countryError, setCountryError] = useState<boolean>(false);
	const [cityError, setCityError] = useState<boolean>(false);

	const [packageWeightDefaults, setPackageWeightDefaults] = useState<
		PackageWeightDefaults[]
	>([]);
	const [packageVolumeDefaults, setPackageVolumeDefaults] = useState<
		PackageWeightDefaults[]
	>([]);
	const [packageValueDefaults, setPackageValueDefaults] = useState<
		PackageValueDefaults[]
	>([]);
	const [customsId, setCustomsId] = useState<number | null>(null);
	const [countryOptions, setCountryOptions] = useState<any>();
	const [cityOptions, setCityOptions] = useState<any>();
	const [allSections, setAllSections] = useState<any>([]);
	const [data, setData] = useState<SelectProps["options"]>([]);
	const [systemCountryId, setSystemCountryId] = useState<any>();
	const [vatValues, setVatValues] = useState<any>([]);
	const [returnable, setReturnable] = useState(false);

	// const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

	const getSystemDefaultCountryId = async () => {
		try {
			setSystemCountryId(parseInt(await getConfigurationValue(2)));
		} catch (error: any) {
			console.log(error);
		}
	};

	const getBuyers = async () => {
		try {
			const response = await api.get("Buyer/select-buyers");
			if (response.status === 200) {
				const result = response?.data;
				setBuyerDropDown(result);
			}
		} catch (error) {
			console.log(error);
		}
	};
	const getVatSelection = async () => {
		try {
			const response = await api.get("Currency/select-vat");
			if (response.status === 200) {
				const result = response?.data;
				setVatValues(result);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getClientPackageWeightDefaults = async (
		selectedCountryId: number
	) => {
		try {
			const response = await api.get(
				"packagedefaults/client-weight-list",
				{ params: { countryId: selectedCountryId } }
			);
			const packageWeightDefaults =
				response.data as PackageWeightDefaults[];
			setPackageWeightDefaults(packageWeightDefaults);
		} catch (err) {
			console.log(err);
		}
	};

	const getClientPackageVolumeDefaults = async (
		selectedCountryId: number
	) => {
		try {
			const response = await api.get(
				"packagedefaults/client-volume-list",
				{ params: { countryId: selectedCountryId } }
			);
			setPackageVolumeDefaults(response.data);
		} catch (err) {
			console.log(err);
		}
	};
	const getClientPackageValueDefaults = async (selectedCountryId: number) => {
		try {
			const response = await api.get(
				"packagedefaults/client-value-list",
				{ params: { countryId: selectedCountryId } }
			);
			setPackageValueDefaults(response.data);
		} catch (err) {
			console.log(err);
		}
	};

	const getPackageDefaults = useCallback(
		async (selectedCountryId: number) => {
			await getClientPackageWeightDefaults(selectedCountryId);
			await getClientPackageVolumeDefaults(selectedCountryId);
			await getClientPackageValueDefaults(selectedCountryId);
		},
		[]
	);

	const fetchGeoData = useCallback(async (latitude: any, longitude: any) => {
		try {
			const response = await api.get("External/get-geo-data", {
				params: {
					lng: longitude,
					lat: latitude,
					category: CONFIG?.zoneShofer ?? "",
				},
			});
			if (response.status === 200) {
				const result = response?.data;
				const section = Number(result.geofences[0]?.name);
				setSectionId(section);
				// setFinalAddress(result.result);
				setGeoData(response.data);
				setAddressError(false);
				// validateSectionWithCityAndCountry(section);
			}
		} catch (error) {
			console.log(error);
		}
	}, []);

	const getZones = useCallback(async () => {
		try {
			const allZones = await fetchZones();
			if (allZones) {
				setZones(allZones);
				const countries = allZones
					.filter((country: Zone) => country.levelId === 1)
					.map((country: Zone) => ({
						value: country.id,
						label: country.description,
					}));
				setCountryOptions(countries);
				const cities = allZones
					.filter(
						(city: Zone) =>
							city.levelId === 2 &&
							(city.parentId === selectedCountry ||
								!selectedCountry)
					)
					.map((city: Zone) => ({
						value: city.id,
						label: city.description,
					}));
				setCityOptions(cities);
				const sections = allZones?.filter(
					(item: any) => item.levelId === 3
				);
				setAllSections(sections);
			} else {
				console.error("Failed to fetch zones.");
			}
		} catch (error) {
			console.error("An error occurred while fetching zones:", error);
		}
	}, [selectedCountry]);

	const fetchData = useCallback(async () => {
		try {
			if (buyerId) {
				setFromBuyerPage(true);
				const response = await api.get("buyer/unlinked-buyer", {
					params: { buyerId: buyerId },
				});
				const data = response.data?.[0];
				if (data) {
					setTemporaryBuyerDetails(data);
					setTemporaryBuyerDetailsId(data.temporaryBuyerDetailsId);
					setSectionId(data?.sectionId);
					setSelectedCountry(data?.countryId);
					setSelectedCity(data?.cityId);
					setFullName(`${data?.firstName} ${data?.lastName}`);
					setAddress(data?.address);
					setAddressDetails(data?.addressDetails);
					// (autocompleteRef as any).current.setInputText(
					// 	data?.address ? data.address : ""
					// );
					setPhone(data?.phone);
					setEmail(data?.email);
					setLatitude(data?.latitude);
					setLongitude(data?.longitude);
					setApiLatitude(data?.latitude);
					setApiLongitude(data?.longitude);
					setAddressPosition([data?.latitude, data?.longitude]);
					setPosition([data?.latitude, data?.longitude]);
					setMapCenter([data?.latitude, data?.longitude]);
					await getPackageDefaults(data?.countryId);
					if (data?.latitude !== null && data?.longitude !== null) {
						setMapCenter([data?.latitude, data?.longitude]);
						setPosition([data?.latitude, data?.longitude]);
					}
					await fetchGeoData(data?.latitude, data?.longitude);
				}
			} else {
				console.error("Buyer ID not found in query parameters.");
				setLatitude(42.6026);
				setLongitude(20.903);
				setMapCenter([42.6026, 20.903]);
			}
		} catch (error) {
			console.error(
				"An error occurred while fetching buyer data:",
				error
			);
		}
	}, [buyerId, fetchGeoData, getPackageDefaults]);

	useEffect(() => {
		getAllCostums();
		getBuyers();
		getVatSelection();
		getZones();
		getSystemDefaultCountryId();
		fetchData();
	}, []);

	const onSelectVat = useCallback(
		(value: any) => {
			const orderPriceIncludeVAT =
				(orderPriceNoVat / 100) * (100 + value);
			setOrderPrice(Number(orderPriceIncludeVAT.toFixed(2)));
			setVat(value);
			setOpenVatModal(false);
		},
		[orderPriceNoVat]
	);

	//ORDER PRICE CHANGE
	const packageValueChange = (e: any) => {
		const inputValue = e.target.value;
		let value = inputValue || 0;

		const originalPrice = (value / (100 + vat)) * 100;
		setOrderPriceNoVat(originalPrice);
		setOrderPrice(value);
		setVat(0);
	};

	const ordersRealPriceChange = (e: any) => {
		const inputValue = e.target.value;

		let value = parseFloat(inputValue);

		if (isNaN(value) || inputValue === "") {
			value = 0;
		}
		setOrdersRealPrice(value);
	};

	const resetStatesToInitial = async () => {
		fetchData();
		setFirstName("");
		setLastName("");
		setAddress("");
		//(autocompleteRef as any).current.handleClear();
		setSectionId(0);
		setPhone("");
		setEmail("");
		setWidth(20);
		setLength(20);
		setHeight(20);
		setWeight(0.5);
		setOpenable(true);
		setFragile(false);
		setDeclared(false);
		setExchangeable(false);
		setDeliveryInstructions("");
		setOrderPrice(0);
		setOrderPriceNoVat(0);
		setCurrencyId(1);
		setOrderDescription("");
		setPackageDescription("");
		setZones([]);
		setSelectedCountry("");
		setSelectedCity("");
		setFullName("");
		setLatitude(42.6026);
		setLongitude(20.903);
		setPosition([42.6026, 20.903]);
		setMapCenter([42.6026, 20.903]);
		setRefId(null);
		setVat(0);
		setCustomsId(null);
		setSearchText("");
		setFromBuyerPage(false);
		setOrdersRealPrice(0);
		setWaitingPickup(false);
		const urlWithoutQuery = window.location.pathname;
		window.history.pushState({}, document.title, urlWithoutQuery);
		await getZones();
		setReturnable(false);
	};

	const validateInsertedData = (data: any) => {
		const {
			firstName,
			lastName,
			address,
			sectionId,
			phone,
			width,
			length,
			height,
			weight,
			orderPrice,
			currencyId,
			packageDescription,
			countryId,
			customsId,
		} = data;

		const isNilOrEmpty = (value: unknown) =>
			value === null ||
			value === undefined ||
			(typeof value === "string" && value.trim() === "");
		const requiresCustomsFields = countryId !== systemCountryId;

		if (
			!firstName ||
			!lastName ||
			!address ||
			!sectionId ||
			!phone ||
			!width ||
			!length ||
			!height ||
			!weight ||
			orderPrice < 0 ||
			!currencyId ||
			!packageDescription ||
			!countryId ||
			(requiresCustomsFields && isNilOrEmpty(customsId))
		) {
			if (!firstName) {
				toast.error("Emri është i detyrueshëm.");
				setNameError(true);
			}
			if (!lastName) toast.error("Mbiemri është i detyrueshëm.");
			if (!address) {
				toast.error("Adresa është e detyrueshme.");
				setAddressError(true);
			}
			if (!phone) {
				toast.error("Numri i telefonit është i detyrueshëm.");
				setPhoneError(true);
			}
			if (!width) toast.error("Gjerësia është e detyrueshme.");
			if (!length) toast.error("Gjatësia është e detyrueshme.");
			if (!height) toast.error("Lartësia është e detyrueshme.");
			if (!weight) toast.error("Pesha është e detyrueshme.");
			if (orderPrice < 0 && !returnable)
				toast.error(
					"Vlera e pakos duhet të jetë më e madhe se zero (0)."
				);
			if (!currencyId) toast.error("Currency ID is required.");
			if (!sectionId)
				toast.error(
					"Kjo zonë nuk është e regjistruar ende.Ju lutem kontaktoni stafin e Postman"
				);
			if (!packageDescription) {
				toast.error("Emërtimi i pakos është i detyrueshëm.");
				setPackageDescriptionError(true);
			}
			if (requiresCustomsFields && isNilOrEmpty(customsId)) {
				toast.error("Kodi koganor është i detyrueshëm");
			}

			return false;
		}

		setNameError(false);
		return true;
	};

	const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

	const handleFileChange = (event: any) => {
		if (event.fileList?.length) {
			const file: any = Array.from(event.fileList);
			setSelectedFiles(file);
		}
	};

	const handleReturnableChange = (checked: boolean) => {
		if (checked && (exchangeable || invoice)) {
			setReturnable(false);
			toast.error(
				"Porosia mund të jetë ose kthim pagese, ose ndërrim, ose faturë!"
			);
			return;
		}
		setReturnable(checked);
	};

	const handleExchangeableChange = (checked: boolean) => {
		if (checked && (returnable || invoice)) {
			setExchangeable(false);
			toast.error(
				"Porosia mund të jetë ose kthim pagese, ose ndërrim, ose faturë!"
			);
			return;
		}
		setExchangeable(checked);
	};

	const handleInvoiceCheck = (checked: boolean) => {
		if (checked && (returnable || exchangeable)) {
			setInvoice(false);
			toast.error(
				"Porosia mund të jetë ose kthim pagese, ose ndërrim, ose faturë!"
			);
			return;
		}
		setInvoice(checked);
	};

	const getClientCompanyFinance = async () => {
		try {
			const response = await api.get("Finance/client-finance");
			if (response) {
				const result = response.data[0];
				return result;
			}
		} catch (error) {
			console.log(error);
		}
	};

	const validateOrderPriceChange = async (
		orderPriceParam: number
	): Promise<boolean> => {
		const clientBalanceInPostman = await getClientCompanyFinance();
		const clientCurrentBalance =
			clientBalanceInPostman?.currentBalance - transportPrice;
		if (clientCurrentBalance <= 0) {
			return false;
		}
		if (clientCurrentBalance < /*rowData?.orderPrice*/ orderPriceParam) {
			return false;
		}
		return true;
	};

	const handleSaveOrder = async () => {
		const fullNameArray = fullName.split(" ");
		const firstName = fullNameArray[0] || "";
		const lastName = fullNameArray.slice(1).join(" ");

		const vatRate = vat / 100;
		const orderPriceNoVat = orderPrice / (1 + vatRate);
		if (!addressDetails) {
			toast.error("Adresa nuk duhet te jete e zbrazet!");
			return;
		}

		const existingSection = allSections?.some(
			(item: any) => sectionId !== null && item.id === sectionId
		);
		if (!existingSection) {
			toast.error(
				"Kjo Zone nuk eshte e regjistruar! Ju lutem kontaktoni Postman"
			);
			return;
		}

		if (returnable) {
			const hasSufficientBalance =
				await validateOrderPriceChange(orderPrice);
			if (!hasSufficientBalance) {
				toast.error(
					"Nuk keni balanc të mjaftueshëm për të krijuar kthim të porosisë"
				);
				return;
			}
		}

		// if (validateSectionWithCityAndCountry(sectionId)) {
		if (fromBuyerPage === true) {
			const currentURL = window.location.search;
			const queryParams = extractQueryParameters(currentURL);
			const userId = queryParams.id;

			const formData = new FormData();
			const extractedFiles = selectedFiles.map(
				(file: any) => file?.originFileObj
			);

			extractedFiles.forEach((file, index) => {
				formData.append("Image", file);
			});

			const order: IOrderInsertData = {
				firstName: firstName,
				lastName: lastName,
				address: address,
				addressDetails: addressDetails,
				sectionId: sectionId,
				phone: phone,
				email: email,
				width: width,
				length: length,
				height: height,
				weight: weight,
				openable: openable,
				fragile: fragile,
				declared: declared,
				packageDescription: packageDescription,
				latitude: apiLatitude?.toString(),
				longitude: apiLongitude?.toString(),
				exchangeable: exchangeable,
				invoice: invoice,
				buyerId: userId,
				deliveryInstructions: deliveryInstructions,
				orderPrice: Number(orderPrice),
				transportPrice: transportPrice,
				currencyId: currencyId,
				orderDescription: orderDescription,
				temporaryBuyerDetailsId: temporaryBuyerDetailsId,
				refId: refId,
				ordersRealPrice: ordersRealPrice,
				orderPriceNoVat: orderPriceNoVat
					? orderPriceNoVat
					: Number(orderPrice),
				vat: vat ?? 0,
				waitingPickup: waitingPickup,
				countryId: selectedCountry,
				customsId: customsId,
				returnable: returnable,
			};
			for (const key in order) {
				formData.append(key, order?.[key]?.toString() ?? "");
			}

			if (validateInsertedData(order)) {
				if (
					(parseInt(orderPrice) === 0 || !orderPrice) &&
					ordersRealPrice === 0
				) {
					setOpenOrdersRealPriceModal(true);
					toast.error("Ju lutem plotesoni Cmimin real te pakos");
					return;
				} else {
					try {
						const response = await api.post(
							"Order/insert-order",
							formData
						);

						if (response.status === 200) {
							toast.success("Porosia u regjistrua me sukses!");
							resetStatesToInitial();
							setTimeout(() => {
								navigate("/order");
							}, 500);
						} else {
							toast.error(
								"Kjo Zone nuk eshte e regjistruar ende"
							);
							console.error("Failed to submit the order.");
						}
					} catch (error: any) {
						console.error(error.response.data);
					}
				}
			} else {
				return;
			}
		} else {
			const formData = new FormData();

			const data: IOrderInsertData = {
				firstName: firstName,
				lastName: lastName,
				address: address,
				addressDetails: addressDetails,
				sectionId: sectionId,
				phone: phone,
				email: email,
				width: width,
				length: length,
				height: height,
				weight: weight,
				openable: openable,
				fragile: fragile,
				declared: declared,
				exchangeable: exchangeable,
				invoice: invoice,
				deliveryInstructions: deliveryInstructions,
				orderPrice: Number(orderPrice),
				transportPrice: transportPrice,
				currencyId: currencyId,
				orderDescription: orderDescription,
				packageDescription: packageDescription,
				latitude: apiLatitude,
				longitude: apiLongitude,
				refId: refId,
				ordersRealPrice: ordersRealPrice,
				waitingPickup: waitingPickup,
				orderPriceNoVat: orderPriceNoVat
					? orderPriceNoVat
					: Number(orderPrice),
				vat: vat ?? 0,
				countryId: selectedCountry,
				customsId: customsId,
				returnable: returnable,
			};

			for (const key in data) {
				formData.append(key, data?.[key]?.toString() ?? "");
			}

			const extractedFiles = selectedFiles.map(
				(file: any) => file?.originFileObj
			);

			extractedFiles.forEach((file, index) => {
				formData.append("Image", file);
			});
			if (validateInsertedData(data)) {
				if (
					(parseInt(orderPrice) === 0 || !orderPrice) &&
					ordersRealPrice === 0
				) {
					setOpenOrdersRealPriceModal(true);
					toast.error("Ju lutem plotesoni Cmimin real te pakos");
					return;
				} else {
					try {
						const response = await api.post(
							"Order/insert",
							formData
						);

						if (response.status === 200) {
							toast.success("Porosia u regjistrua me sukses!");
							resetStatesToInitial();
							setTimeout(() => {
								navigate("/order");
							}, 500);
						} else {
							toast.error(
								"Kjo Zone nuk eshte e regjistruar ende"
							);
							console.error("Failed to submit the order.");
						}
					} catch (error: any) {
						console.error(error.response.data);
					}
				}
			} else {
				return;
			}
		}
		// }
	};

	const handleCityChange = (value: any) => {
		if (value?.value) {
			const id = value.value;
			setSelectedCity(id);
			setCityError(false);
			setAddress("");
			setData([]);
		} else {
			setSelectedCity("");
			setAddress("");
			setData([]);
		}
	};

	const customIcon = new Icon({
		iconUrl: require("../../assets/pin.png"),
		iconSize: [38, 38],
	});

	const eventHandlers = useMemo(
		() => ({
			dragend() {
				const marker = markerRef.current;
				if (marker != null) {
					const latLng = marker["_latlng"];
					setPosition(latLng);
					setApiLatitude(latLng["lat"]);
					setApiLongitude(latLng["lng"]);
					fetchGeoData(latLng["lat"], latLng["lng"]);
				}
			},
		}),
		[]
	);

	const handleCityOptionsBasedOnCountry = (countryId: any) => {
		const filteredCities = zones
			.filter((item: Zone) => item.parentId === countryId)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setCityOptions(filteredCities);
	};
	const handleCountryChange = async (countryId: number) => {
		setCountryError(false);
		setSelectedCity("");
		setAddress("");
		setData([]);
		setSectionId(0);
		setSelectedCountry(countryId);

		switch (countryId) {
			case 1: // Kosovo
				setMapCenter([42.6026, 20.903]);
				setCountryLabel("xk");
				break;
			case 2: // Albania
				setMapCenter([41.1533, 20.1683]);
				setCountryLabel("al");
				break;
			case 3: // North Macedonia
				setMapCenter([41.6086, 21.7453]);
				setCountryLabel("mk");
				break;
			default:
				break;
		}

		setPosition(null);
		handleCityOptionsBasedOnCountry(countryId);
		await getPackageDefaults(countryId);
	};

	const handleSearch = (address: any) => {
		if (!selectedCountry || !selectedCity) {
			toast.error("Ju lutem zgjedhni shtetin dhe qytetin");
			setAddress("");
			setCountryError(true);
			setCityError(true);
			return;
		}
	};

	const handleChange = (address: any) => {
		const selectedLocation = address;
		if (selectedLocation) {
			const lat = selectedLocation.lat;
			const lng = selectedLocation.lng;
			setAddressPosition([lat, lng]);
			setPosition([lat, lng]);
			setApiLatitude(lat);
			setApiLongitude(lng);
			fetchGeoData(lat, lng);
			setAddress(selectedLocation.label ?? "");
		}
	};

	const ResetCenterView = (props: any) => {
		const { selectedPosition } = props;
		const { addressPosition } = props;
		const map = useMap();
		useEffect(() => {
			if (selectedPosition === 1) {
				map.setView(L.latLng(42.6026, 20.903), map.getZoom(), {
					animate: true,
				});
			} else if (selectedPosition === 2) {
				map.setView(L.latLng(41.1533, 20.1683), map.getZoom(), {
					animate: true,
				});
			} else if (selectedPosition === 3) {
				map.setView(L.latLng(41.6086, 21.7453), map.getZoom(), {
					animate: true,
				});
			}
			if (addressPosition) {
				map.setView(L.latLng(addressPosition), 15, {
					animate: true,
				});
			}
		}, [addressPosition, map, selectedPosition]);

		return null;
	};

	const clearSearchedBuyer = () => {
		setSectionId(0);
		setSelectedCountry("");
		setSelectedCity("");
		setFullName("");
		setAddress("");
		setPhone("");
		setEmail("");
		setSearchText("");
	};

	const setBuyerInputs = (data: any) => {
		console.log(data, "data");
		setSectionId(data?.sectionId);
		setSelectedCountry(data?.countryId);
		setSelectedCity(data?.cityId);
		setFullName(`${data?.firstName} ${data?.lastName}`);
		setAddress(data?.address);
		setAddressDetails(data?.addressDetails);
		setFinalAddress(data?.address);
		setPhone(data?.phone);
		setEmail(data?.email);
		setLatitude(data?.latitude);
		setLongitude(data?.longitude);
		setApiLatitude(data?.latitude);
		setApiLongitude(data?.longitude);
		const filterCity = zones?.find(
			(item: any) => item?.id === data?.cityId
		);
	};

	const filterOption = (
		input: string,
		option?: { label: string; value: string }
	) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const onBuyerSeachChange = async (value: string) => {
		setSearchText(value);
		const selectedBuyer = buyerDropDown?.find(
			(item: any) => item.id === value
		);
		setBuyerInputs(selectedBuyer);
		setNameError(false);
		setAddressError(false);
		setPhoneError(false);
		setPackageDescriptionError(false);
		setCustomsId(null);
		await getPackageDefaults(selectedBuyer?.countryId);
	};

	const getAllCostums = async () => {
		try {
			const response = await api.get("ListOptions/get-costums");
			if (response.status === 200) {
				const result = response?.data;
				setCostums(result);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const renderCostumOptions = () => {
		const costumOptions = costums.map((costum: any) => ({
			value: costum.id,
			label: `${costum.costumsCode} -  ${costum.description}`,
		}));

		return [...costumOptions];
	};

	const getPackageVolume = (
		volume: number,
		packageVolumeDefaults: PackageWeightDefaults[]
	) => {
		const packageVolume = packageVolumeDefaults.find((pv) =>
			pv.to != null
				? pv.from <= volume && pv?.to > volume
				: pv.from <= volume
		);
		return packageVolume;
	};
	const getPackageValue = (
		packageValuePrice: number,
		packageValueDefaults: PackageValueDefaults[]
	) =>
		packageValueDefaults?.find((pv) =>
			pv.to != null
				? pv.from <= packageValuePrice && pv?.to > packageValuePrice
				: pv.from <= packageValuePrice
		);
	const getPackageWeight = (
		weight: number,
		packageWeightDefaults: PackageWeightDefaults[]
	) =>
		packageWeightDefaults?.find((pv) =>
			pv.to != null
				? pv.from <= weight && pv?.to > weight
				: pv.from <= weight
		);

	const packageValue = useMemo<PackageValueDefaults | undefined>(
		() =>
			getPackageValue(
				orderPrice > ordersRealPrice ? orderPrice : ordersRealPrice,
				packageValueDefaults
			),
		[orderPrice, ordersRealPrice, packageValueDefaults]
	);

	const calculatePricePackageVolume = (
		packageVolumePrice: number,
		packageWeightPrice: number,
		packageValuePrice: number,
		packageValuePercentage: number
	) => {
		const priceByVolume = packageVolumePrice ?? 0;
		const priceByWeight = packageWeightPrice ?? 0;
		const priceByValue =
			packageValuePrice * ((packageValuePercentage ?? 0) / 100);

		return priceByVolume + priceByWeight + priceByValue;
	};

	const volume = width * length * height;

	const packageVolume = useMemo<PackageWeightDefaults | undefined>(
		() => getPackageVolume(volume, packageVolumeDefaults),
		[volume, packageVolumeDefaults]
	);

	const packageWeight = useMemo(
		() => getPackageWeight(weight, packageWeightDefaults),
		[packageWeightDefaults, weight]
	);

	const transportPrice = useMemo(() => {
		return calculatePricePackageVolume(
			packageVolume?.price as number,
			packageWeight?.price as number,
			orderPrice > ordersRealPrice ? orderPrice : ordersRealPrice,
			packageValue?.percentage as number
		);
	}, [
		packageVolume?.price,
		packageWeight?.price,
		orderPrice,
		ordersRealPrice,
		packageValue?.percentage,
	]);

	const profit = (orderPrice - transportPrice).toFixed(2);

	const onWidthChange = (e: any) => {
		if (parseInt(e.target.value) < 0) {
			setWidth(20);
		} else {
			setWidth(e.target.value);
		}
	};

	const onLengthChange = (e: any) => {
		if (parseInt(e.target.value) < 0) {
			setLength(20);
		} else {
			setLength(e.target.value);
		}
	};
	const onHeightChange = (e: any) => {
		if (parseInt(e.target.value) < 0) {
			setHeight(20);
		} else {
			setHeight(e.target.value);
		}
	};

	const onWeightChange = (e: any) => {
		if (parseInt(e.target.value) < 0) {
			setWeight(0.5);
		} else {
			setWeight(e.target.value);
		}
	};

	const onCustomSelect = (value: any) => {
		setCustomsId(value);
	};

	const onFullNameChange = (e: any) => {
		var alphaExp = /^[a-zA-Z ]+$/;
		if (e.target.value.match(alphaExp)) {
			setFullName(e.target.value);
			setNameError(false);
		} else {
			setFullName("");
			toast.error(
				"Numrat dhe shenjat nuk lejohen tek emri dhe mbiemri i bleresit!"
			);
			return;
		}
	};

	const { strings } = useLang("registerOrderForm");
	return (
		<>
			<div className={classes.registerContainerOrder}>
				<div className={classes.oneContainer}>
					<h1 className={classes.title}>{strings?.title}</h1>
					<div className={classes.inputsFrame}>
						<h1 className={classes.titleinfo}>
							{strings?.titleInfoBuyer}
						</h1>

						<div className={classes.inputsMapContainer}>
							<div className={classes.inputsHero}>
								<div className={classes.buyerDropDownContainer}>
									<label className="w-42 -mb-2">
										{strings?.searchLabel}
									</label>
									<Select
										showSearch
										value={searchText}
										placeholder={strings?.searchPlaceholder}
										className={classes.input}
										onChange={onBuyerSeachChange}
										optionFilterProp="children"
										filterOption={filterOption}
										options={buyerDropDown?.map(
											(buyer: any) => ({
												value: buyer.id,
												label: `${buyer.firstName} ${buyer.lastName} (${buyer.phone}) `,
											})
										)}
										allowClear={true}
										onClear={clearSearchedBuyer}
									/>
								</div>
								<div className={classes.inputsContainer}>
									<DefaultInput
										className={classes.input}
										placeholder={
											strings?.fullNamePlaceholder
										}
										value={fullName}
										onChange={(e) => onFullNameChange(e)}
										label={strings?.fullNameLabel}
										status={nameError ? "error" : ""}
										type="text"
									/>
									<DefaultInput
										placeholder={strings?.emailPlaceholder}
										value={email}
										onChange={(e) =>
											setEmail(e.target.value)
										}
										className={classes.input}
										label={strings?.emailLabel}
									/>
									<DefaultSelect
										className={classes.input}
										onChange={handleCountryChange}
										value={selectedCountry}
										placeholder={
											strings?.countryPlaceholder
										}
										label={strings?.countryLabel}
										flexDirection="col"
										alignCenter="start"
										options={countryOptions}
										allowClear
										status={countryError ? "error" : ""}
									/>
									<DefaultSelect
										className={classes.input}
										placeholder={strings?.cityPlaceholder}
										value={selectedCity}
										onChange={handleCityChange}
										label={strings?.cityLabel}
										flexDirection="col"
										alignCenter="start"
										options={cityOptions}
										allowClear
										labelInValue={true}
										status={cityError ? "error" : ""}
										disabled={!selectedCountry}
									/>
									<div className="flex flex-col items-start">
										<label className="w-42 -mb-0">
											{strings?.addressLabel}
										</label>

										<AddressSelect
											onAddressChange={handleChange}
											country={countryLabel}
											selectedAddress={address}
											city={selectedCity}
										/>
									</div>
									<DefaultInput
										className={classes.input}
										label={strings?.addressDetailsLabel}
										placeholder={
											strings?.addressDetailsPlaceholder
										}
										value={addressDetails}
										onChange={(e) => {
											setAddressDetails(e.target.value);
										}}
									/>
									<DefaultInput
										className={classes.input}
										label={strings?.phoneLabel}
										placeholder={strings?.phonePlaceholder}
										value={phone}
										onChange={(e) => {
											setPhone(e.target.value);
											setPhoneError(false);
										}}
										status={phoneError ? "error" : ""}
									/>
								</div>
							</div>
							<div className={classes.mapContainer}>
								{mapCenter !== null && (
									<MapContainer
										center={mapCenter}
										zoom={7.5}
										scrollWheelZoom={false}
										className={classes.map}
									>
										<TileLayer
											attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
											url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
										/>
										{position !== null && (
											<>
												<Marker
													draggable={false}
													position={position}
													icon={customIcon}
													eventHandlers={
														eventHandlers
													}
													ref={markerRef}
												>
													<Popup
														minWidth={90}
													>{`Position${position}`}</Popup>
												</Marker>
											</>
										)}
										<ResetCenterView
											selectedPosition={selectedCountry}
											addressPosition={adressPosition}
										/>
									</MapContainer>
								)}
								{(!latitude || !longitude) && (
									<p>{error || strings?.fetchingLocation}</p>
								)}
							</div>
						</div>
						<div className={classes.secondInputs}>
							<h1 className={classes.titleinfo}>
								{strings?.packageDataTitle}
							</h1>
							<div className={classes.fatura}>
								<DefaultSwitch
									label={strings?.invoiceLabel}
									checked={invoice}
									onChange={handleInvoiceCheck}
								/>
								<DefaultSwitch
									label="Kthim Pagese"
									checked={returnable}
									onChange={handleReturnableChange}
								/>
							</div>
							<div className={classes.inputsDiv}>
								<DefaultInput
									className={classes.inputItem}
									onChange={(e) => {
										setPackageDescription(e.target.value);
										setPackageDescriptionError(false);
									}}
									label={strings?.packageDescriptionLabel}
									value={packageDescription}
									placeholder={
										strings?.packageDescriptionPlaceholder
									}
									status={
										packageDescriptionError ? "error" : ""
									}
								/>
								<div className="flex flex-col gap-2">
									<DefaultInput
										className={classes.inputItem}
										onChange={packageValueChange}
										label={
											strings?.packageValueLabel +
											CONFIG?.CURRENCY
										}
										placeholder={
											strings?.packageValuePlaceholder
										}
										suffix={CONFIG?.CURRENCY}
										type="number"
										min={0}
										value={orderPrice}
									/>
									<Button
										type="default"
										style={{ color: "blue" }}
										onClick={() => setOpenVatModal(true)}
										className={classes.buttonVat}
									>
										{strings?.selectVatButton}
									</Button>
								</div>

								<DefaultInput
									className={classes.inputItem}
									onChange={(e) => setRefId(e.target.value)}
									label={strings?.refIdLabel}
									value={refId}
									placeholder={strings?.refIdPlaceholder}
								/>
								<div className={classes.fileDiv}>
									<Upload
										onChange={handleFileChange}
										multiple={true}
										accept="image/*"
										beforeUpload={() => false}
									>
										<Button
											icon={<UploadOutlined />}
											className="buttonUploadFile"
										>
											{strings?.upload}
										</Button>
									</Upload>
								</div>

								{selectedCountry &&
									selectedCountry !== systemCountryId && (
										<DefaultSelect
											placeholder={
												strings?.customsCodePlaceholder
											}
											className={classes.input}
											options={renderCostumOptions()}
											label={strings?.customsCodeLabel}
											flexDirection="col"
											alignCenter="start"
											value={customsId}
											onChange={onCustomSelect}
										/>
									)}
							</div>
							<div className={classes.inputsAreaDiv}>
								<div className={classes.textAreaDiv}>
									<label>
										{strings?.packageDescriptionAreaLabel}
									</label>
									<TextArea
										className={classes.textarea}
										value={orderDescription}
										onChange={(e) =>
											setOrderDescription(e.target.value)
										}
										placeholder={
											strings?.packageDescriptionAreaPlaceholder
										}
									/>
								</div>
								<div className={classes.textAreaDiv}>
									<label>
										{strings?.deliveryInstructionsLabel}
									</label>
									<TextArea
										className={classes.textarea}
										value={deliveryInstructions}
										onChange={(e) =>
											setDeliveryInstructions(
												e.target.value
											)
										}
										placeholder={
											strings?.deliveryInstructionsPlaceholder
										}
									/>
								</div>
								<div className={classes.switchButtons}>
									<DefaultSwitch
										label={strings?.exchangeableLabel}
										checked={exchangeable}
										onChange={handleExchangeableChange}
									/>
									<DefaultSwitch
										label={strings?.readyForPickupLabel}
										checked={waitingPickup}
										onChange={(checked) =>
											setWaitingPickup(checked)
										}
									/>
									<DefaultSwitch
										label={strings?.fragileLabel}
										checked={fragile}
										onChange={(checked) =>
											setFragile(checked)
										}
									/>

									<DefaultSwitch
										label={strings?.declaredLabel}
										checked={declared}
										onChange={(checked) =>
											setDeclared(checked)
										}
									/>
								</div>
							</div>
						</div>
						<div className={classes.thirdInputs}>
							<h1 className={classes.titleinfo}>
								{strings?.transportCostTitle}
							</h1>
							<div className={classes.inputWeight}>
								<div className={classes.firstHero}>
									<OrderBox />
									<div className={classes.inputat}>
										<DefaultInput
											className={classes.inputDimensions}
											onChange={onWidthChange}
											value={width}
											label={strings?.widthLabel}
											placeholder={
												strings?.widthPlaceholder
											}
											type="number"
											min={10}
										/>
										<DefaultInput
											className={classes.inputDimensions}
											onChange={onLengthChange}
											value={length}
											label={strings?.lengthLabel}
											placeholder={
												strings?.lengthPlaceholder
											}
											type="number"
											min={10}
										/>
										<DefaultInput
											className={classes.inputDimensions}
											onChange={onHeightChange}
											value={height}
											label={strings?.heightLabel}
											placeholder={
												strings?.heightPlaceholder
											}
											type="number"
											min={10}
										/>
									</div>
								</div>
								<div className={classes.secondHero}>
									<div className={classes.lastInputs}>
										<DefaultInput
											className={classes.lastinput}
											onChange={onWeightChange}
											value={weight}
											label={strings?.weightLabel}
											placeholder={
												strings?.weightPlaceholder
											}
											type="number"
											min={0}
										/>
										<DefaultInput
											label={strings?.packageSizeLabel}
											className={classes.lastinput}
											value={
												packageVolume
													? `${packageVolume?.from} - ${
															packageVolume?.to ??
															"më shumë"
													  }`
													: ""
											}
											suffix="cm³"
											disabled
										/>
									</div>
									<div className={classes.lastInputs}>
										<DefaultInput
											label={strings?.transportCostLabel}
											className={classes.lastinput}
											value={transportPrice?.toFixed(2)}
											disabled
											suffix={CONFIG?.CURRENCY}
										/>
										<DefaultInput
											label={strings?.profitLabel}
											className={classes.lastinput}
											value={profit}
											placeholder="Shëno"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<Divider />
					<div className={classes.buttons}>
						<Buttons
							button1Text={strings?.cancelButtonText}
							button2Text={strings?.registerButtonText}
							onButton2Click={handleSaveOrder}
							onButton1Click={resetStatesToInitial}
						/>
					</div>
				</div>
			</div>
			<Modal
				title={strings?.vatModalTitle}
				open={openVatModal}
				onCancel={() => setOpenVatModal(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
			>
				<Divider />
				<div className="flex flex-row justify-around">
					{vatValues.map((vatOption: any) => (
						<Button
							key={vatOption.id}
							className={
								vat === vatOption.value
									? classes.selectedVat
									: undefined
							}
							type="default"
							onClick={() => onSelectVat(vatOption.value)}
						>
							{vatOption.value}%
						</Button>
					))}
				</div>
			</Modal>

			<Modal
				title={"Porosia nuk regjistohet!"}
				open={openOrdersRealPriceModal}
				okButtonProps={{ style: { display: "none" } }}
				cancelButtonProps={{ style: { display: "none" } }}
				onCancel={() => {
					setOrdersRealPrice(0);
					setOpenOrdersRealPriceModal(false);
				}}
			>
				<div className="flex flex-col gap-8">
					<div className="custom-alert custom-alert-error">
						<div className="custom-alert-icon">{<AlertIcon />}</div>
						<div className="custom-alert-content">
							<div>
								<p>
									<b>
										{" "}
										{"Porosia nuk mund të regjistrohet! "}
									</b>
									{"Pavarësisht se vlera e pakos është "}{" "}
									<b>0€</b>
									{
										" dhe blerësi juaj nuk do të paguaj asgjë, ne duhet të dijmë vlerën reale të porosisë.Kjo vlerë nuk shfaqet në etiketë"
									}
								</p>
							</div>
						</div>
					</div>
					<div className="flex  flex-col gap-8">
						<DefaultInput
							className={classes.modalInputItem}
							onChange={ordersRealPriceChange}
							label={strings?.realPackageValueLabel}
							value={ordersRealPrice}
							suffix={CONFIG?.CURRENCY}
							type="number"
							min={0}
						/>
						<DefaultInput
							label={strings?.transportCostLabel}
							className={classes.modalInputItem}
							value={transportPrice?.toFixed(2)}
							disabled
							suffix={CONFIG?.CURRENCY}
						/>
					</div>
					<Buttons
						button1Text="Mbyll"
						onButton1Click={() => {
							setOrdersRealPrice(0);
							setOpenOrdersRealPriceModal(false);
						}}
						button2Text="Apliko"
						onButton2Click={handleSaveOrder}
					/>
				</div>
			</Modal>
		</>
	);
};

export default Register;
